var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('HelloWorld',{attrs:{"signature":_vm.signature,"username":_vm.username,"useremail":_vm.useremail,"meetingid":_vm.meetingid,"leaveurl":_vm.leaveurl,"clientid":_vm.clientid}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }